import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { LoaderContext } from '../../AuthContext/AuthContext';
import kitBox from "../../assets/images/new/pujaKitBox.jpg";
import Annual from "../../assets/images/new/Anual.jpg";
import Six from "../../assets/images/new/6-months.jpg";
import month from "../../assets/images/new/one-month.jpg";
import Queterly from "../../assets/images/new/Queterly.jpg";
import PujaKitFront from "../../assets/images/new/PujaKitFront.png";

import innerItem from "../../assets/images/new/innerItem.jpg";
import OpenBox from "../../assets/images/new/OpenBox.jpg";
import { GetWebProductSubscriptionPlanList, PujaKitSubscriptionPlanList } from '../../ApiServices/PujaSubscription/PujaSubscriptionApi';
import { SubscriptionPackage } from '../../ApiServices/SubscriptionPackage/SubscriptionPackageApi';
import NoResultFoundModel from '../../Components/NoDataFound/NoDataFoundModal';
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import { t } from 'i18next';

const SankalpPujasPackageList = ({ serviceName, pujaKeyID, setSelectedPackage, isSubscriptionProductCategory }) => {
    const { setLoader, loader, convertTo12Hour, selectedLanguageID } = useContext(LoaderContext);
    const navigate = useNavigate();

    const [showProfile, setProfile] = useState(false);
    const [subscriptionDetails, setSubscriptionDetails] = useState([kitBox, innerItem, OpenBox,]);
    const [showOpenLoginModal, setShowOpenLoginModal] = useState(false);
    const userID = localStorage.getItem("userID");
    const [templeDetails, setTempleDetails] = useState([kitBox, innerItem, OpenBox]);
    const [cardImages, setCardImages] = useState([month, Queterly, Six, Annual]);

    const [totalRecords, setTotalRecords] = useState(-1)

    useEffect(() => {

        if (isSubscriptionProductCategory) {
            GetWebProductSubscriptionPlanListData()
        } else {
            SubscriptionPackageData()
        }
    }, [selectedLanguageID])



    const SubscriptionPackageData = async () => {
        setLoader(true)
        try {
            const response = await SubscriptionPackage(pujaKeyID, Number(selectedLanguageID)); // Call your API with the slug
            if (response?.statusCode === 200) {
                setLoader(false);
                const list = response?.responseData?.data;


                setSubscriptionDetails(list)
                // setMainImage(list?.pujaImageUrl)

                // setTotalRecords(list?.length)
                setTotalRecords(1)

            } else {
                setLoader(false);
                setTotalRecords(0)
            }
        } catch (error) {
            setLoader(false)
            console.error("Error fetching temple details:", error);
        }
    }

    const GetWebProductSubscriptionPlanListData = async () => {

        setLoader(true)
        try {
            const response = await GetWebProductSubscriptionPlanList(pujaKeyID, Number(selectedLanguageID)); // Call your API with the slug
            if (response?.statusCode === 200) {
                setLoader(false)
                const list = response?.responseData?.data;
                setSubscriptionDetails(list)
                if (list?.length === 0) {
                    return;
                }
            }
        } catch (error) {
            setLoader(false)
            console.error("Error fetching temple details:", error);
        }
    }
    const HandleSelectedPackage = (value) => {

        setSelectedPackage(value)
    }

    return (
        <>
            {/* Subscription Cards */}
            {subscriptionDetails?.length > 0 && (
                <div className="row g-4 justify-content-center">
                    <div
                        className="section-title text-center"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <h6 className="sec-title__tagline bw-split-in-right">
                            <img className=" tagline-img" src={pandit} alt="" />
                            {t("Packages")}
                        </h6>

                        <h3 className="sec-title__title bw-split-in-left">
                            {t(`${serviceName} Packages`)}
                        </h3>
                    </div>
                    {isSubscriptionProductCategory ? (

                        subscriptionDetails.map((pkg, index) => (
                            <div
                                key={index}
                                className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex"
                                style={{ cursor: "pointer" }}
                            >
                                <div
                                    className="card shadow-sm border rounded-3 flex-fill text-center d-flex flex-column"
                                    style={{
                                        borderColor: "#ccc",
                                        boxShadow: "0 6px 12px rgba(0,0,0,0.1)",
                                        padding: "16px",
                                    }}
                                    onClick={() => HandleSelectedPackage(pkg)}
                                >
                                    {/* Header */}
                                    <div className="mb-2">
                                        <h6 className="fw-bold" style={{ fontSize: '20px', color: '#a42642' }}>{pkg?.title}</h6>
                                        {Number(pkg.discountedAmount) > 0 ? (
                                            <p className="fw-bold mb-1" style={{ fontSize: '15px' }}>
                                                ₹{Math.round(Number(pkg.discountedAmount))}{" "}
                                                <span
                                                    style={{
                                                        fontSize: "10px",
                                                        textDecoration: "line-through",
                                                        color: "#888",
                                                    }}
                                                >
                                                    ₹{Math.round(Number(pkg.price))}
                                                </span>
                                            </p>
                                        ) : (
                                            <p className="fw-bold fs-5 mb-1">
                                                ₹{Math.round(Number(pkg.price))}
                                            </p>
                                        )}

                                    </div>

                                    {/* Description */}
                                    <div className="text-start mb-3 flex-grow-1" style={{ fontSize: "14px", lineHeight: "1.6" }}>
                                        <div dangerouslySetInnerHTML={{
                                            __html: pkg?.description

                                        }} />

                                    </div>

                                    {/* Button at Bottom */}
                                    <div style={{ marginTop: "auto" }}>
                                        <button
                                            className="btn w-100"
                                            style={{
                                                backgroundColor: "#991b3d",
                                                color: "#fff",
                                                borderRadius: "8px",
                                                fontWeight: "500",
                                            }}
                                            onClick={() => HandleSelectedPackage(pkg)}
                                        >
                                            {t("PURCHASE NOW")}
                                        </button>
                                    </div>
                                </div>
                            </div>

                        ))

                    ) : (

                        subscriptionDetails.map((pkg, index) => (
                            <div
                                key={index}
                                className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex"
                                style={{ cursor: "pointer" }}
                            >
                                <div
                                    className="card shadow-sm border rounded-3 flex-fill text-center d-flex flex-column"
                                    style={{
                                        borderColor: "#ccc",
                                        boxShadow: "0 6px 12px rgba(0,0,0,0.1)",
                                        padding: "16px",
                                    }}
                                    onClick={() => HandleSelectedPackage(pkg)}
                                >
                                    {/* Header */}
                                    <div className="mb-2">
                                        <h6 className="fw-bold" style={{ fontSize: '20px', color: '#a42642' }}>{pkg?.title}</h6>
                                        {Number(pkg.pujaDiscountAmount) > 0 ? (
                                            <p className="fw-bold mb-1" style={{ fontSize: '15px' }}>
                                                ₹{Math.round(Number(pkg.price) - Number(pkg.pujaDiscountAmount))}{" "}
                                                <span
                                                    style={{
                                                        fontSize: "10px",
                                                        textDecoration: "line-through",
                                                        color: "#888",
                                                    }}
                                                >
                                                    ₹{Math.round(Number(pkg.price))}
                                                </span>
                                            </p>
                                        ) : (
                                            <p className="fw-bold fs-5 mb-1">
                                                ₹{Math.round(Number(pkg.price))}
                                            </p>
                                        )}
                                        <p className='pb-2'
                                            style={{
                                                fontSize: "13px",
                                                borderBottom: '2px solid #a426424f',
                                                marginBottom: "6px",
                                                color: "#a42642"
                                            }}>
                                            {pkg?.subTitle}
                                        </p>
                                    </div>

                                    {/* Description */}
                                    <div className="text-start mb-3 flex-grow-1" style={{ fontSize: "14px", lineHeight: "1.6" }}>
                                        <div dangerouslySetInnerHTML={{
                                            __html: pkg?.description

                                        }} />
                                        {/* <ul style={{ listStyle: "none", paddingLeft: "0", margin: "0" }}>
                                    {pkg?.Description && (
                                        <li style={{ marginBottom: "6px" }}>
                                            <span style={{ color: "#991b3d", fontWeight: "bold" }}>➤</span>{" "}
                                            <span>{pkg.Description}</span>
                                        </li>
                                    )}
                                    {pkg?.timeLine && (
                                        <li style={{ marginBottom: "6px" }}>
                                            <span style={{ color: "#991b3d", fontWeight: "bold" }}>➤</span> {t("Duration")}: {pkg.timeLine}
                                        </li>
                                    )}
                                    {pkg?.timeLineInWeeks && (
                                        <li style={{ marginBottom: "6px" }}>
                                            <span style={{ color: "#991b3d", fontWeight: "bold" }}>➤</span> {t("Timeline in Weeks")}: {pkg.timeLineInWeeks}
                                        </li>
                                    )}
                                    {pkg?.dayName && (
                                        <li style={{ marginBottom: "6px" }}>
                                            <span style={{ color: "#991b3d", fontWeight: "bold" }}>➤</span> {t("Day")}: {pkg.dayName}
                                        </li>
                                    )}
                                    {pkg?.pujaTime && (
                                        <li style={{ marginBottom: "6px" }}>
                                            <span style={{ color: "#991b3d", fontWeight: "bold" }}>➤</span> {t("Puja Time")}: {convertTo12Hour(pkg.pujaTime)}
                                        </li>
                                    )}
                                </ul> */}
                                    </div>

                                    {/* Button at Bottom */}
                                    <div style={{ marginTop: "auto" }}>
                                        <button
                                            className="btn w-100"
                                            style={{
                                                backgroundColor: "#991b3d",
                                                color: "#fff",
                                                borderRadius: "8px",
                                                fontWeight: "500",
                                            }}
                                            onClick={() => HandleSelectedPackage(pkg)}
                                        >
                                            {t("PURCHASE NOW")}
                                        </button>
                                    </div>
                                </div>
                            </div>

                        ))

                    )}

                </div>
            )}



            {/* {totalRecords <= 0 && <NoResultFoundModel totalRecords={totalRecords} />} */}

        </>
    )
}

export default SankalpPujasPackageList
